<div class="Center">
	<h4>Users</h4>
</div>

<p-table
	#mydt
	[value]="lstUsers"
	[loading]="loading"
	[paginator]="true"
	[(rows)]="pagerows"
	[(first)]="pagefirst"
	[showCurrentPageReport]="true"
	[resizableColumns]="false"
	sortMode="multiple"
	styleClass="p-datatable-striped"
	selectionMode="multiple"
	[(selection)]="SelectedUsers"
	dataKey="UserID"
	(onFilter)="onHandleFilter($event)"
	(onSort)="onHandleSort($event)"
	(onRowSelect)="onRowSelect($event)"
	(onRowUnselect)="onRowUnselect($event)"
	currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
	[rowsPerPageOptions]="[5, 10, 25, 50]"
>
	<!--Headers-->
	<ng-template pTemplate="header">
		<!--Filter or Select from Dropdown-->
		<tr>
			<!--Selected-->
			<th></th>

			<!--Code-->
			<th>
				<p-columnFilter type="text" field="UserName" matchMode="contains" [showMenu]="true"></p-columnFilter>
			</th>
			<!--Description-->
			<th>
				<p-columnFilter type="text" field="PersonName" matchMode="contains" [showMenu]="true"></p-columnFilter>
			</th>
		</tr>

		<!--Column Names-->
		<tr style="height: 4rem">
			<th>
				<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
			</th>
			<th pSortableColumn="UserName">User Name<p-sortIcon field="UserName"></p-sortIcon></th>
			<th pSortableColumn="PersonName">Person Name<p-sortIcon field="PersonName"></p-sortIcon></th>
		</tr>
	</ng-template>

	<!--Data-->
	<ng-template pTemplate="body" let-user>
		<tr [pSelectableRow]="user">
			<td>
				<p-tableCheckbox [pSelectableRow]="user" [value]="user"></p-tableCheckbox>
			</td>
			<td *ngFor="let col of cols" style="font-weight: bold">
				{{ user[col.field] }}
			</td>
		</tr>
	</ng-template>
</p-table>

<div class="Center TopMargin">
	<button class="btn btn-primary" (click)="onAdd()">Add</button>
	<button class="btn btn-primary" (click)="onRemove()">Remove</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
